import { cloneObject } from 'utils';
import SearchConfig from '@sun-chemical/system-config/search-config';
import base from 'stores/search-base/getters';

export default {
  ...base,
  filters(state, getters, rootState, rootGetters) {
    const filters = cloneObject(state.filterConfig);
    const { urlFilters } = getters;

    Object.keys(filters).forEach((filterCategory) => {
      const filtersPerCategory = filters[filterCategory];
      const allAggs = getters.aggregations;
      const categoryAggs = filterCategory === 'generic' ? allAggs : allAggs[filterCategory];

      Object.keys(filtersPerCategory).forEach((filterCode) => {
        const config = cloneObject(filters[filterCategory][filterCode]);
        if (!config.accessLevel || rootGetters['user/permissions'][config.accessLevel]) {
          const filterParam = SearchConfig.getMap()[filterCode].param;

          let filterAggs = null;

          // Check the aggregations per category/industry, try to fallback to the generic one
          if (categoryAggs && typeof categoryAggs[filterCode] !== 'undefined') {
            filterAggs = categoryAggs[filterCode];
          } else if (allAggs && typeof allAggs[filterCode] !== 'undefined') {
            filterAggs = allAggs[filterCode];
          }

          if (filterAggs) {
            // has property with the filterCode name, so is nested
            if (typeof filterAggs[filterCode] !== 'undefined') {
              filterAggs = filterAggs[filterCode].buckets.map((bucket) => bucket.key);
            } else if (typeof filterAggs.buckets !== 'undefined') {
              filterAggs = filterAggs.buckets.map((bucket) => bucket.key);
            } else if (Array.isArray(filterAggs)) {
              filterAggs = filterAggs.map((bucket) => bucket.key);
            }
          }

          filters[filterCategory][filterCode].param = filterParam;

          if (config.type === 'multi' || config.type === 'color' || config.type === 'industry') {
            filters[filterCategory][filterCode].options = [];
            config.options.forEach((option) => {
              const filterObject = {
                ...option,
                selected: null,
                disabled: filterAggs && Array.isArray(filterAggs) && filterAggs.indexOf(option.code) === -1
              };

              if (urlFilters.hasOwnProperty(filterParam)) {
                let activeFilters = urlFilters[filterParam];
                if (typeof activeFilters === 'string') {
                  activeFilters = [activeFilters];
                }
                filterObject.selected = activeFilters.indexOf(option.code) > -1;
              }

              // Prevent disabling currently active filters
              if (filterObject.selected && filterObject.disabled) {
                filterObject.disabled = false;
              }

              filters[filterCategory][filterCode].options.push(filterObject);
            });
          }

          if (config.type === 'boolean' || config.type === 'checkbox') {
            filters[filterCategory][filterCode].selected = urlFilters.hasOwnProperty(filterParam)
              ? !!urlFilters[filterParam]
              : null;
            filters[filterCategory][filterCode].disabled = filterAggs
              && Array.isArray(filterAggs)
              && filterAggs.indexOf(1) === -1
              && !filters[filterCategory][filterCode].selected;
          }

          if (config.type === 'range') {
            filters[filterCategory][filterCode].value = urlFilters.hasOwnProperty(filterParam)
              ? urlFilters[filterParam]
              : null;
          }
        } else {
          delete filters[filterCategory][filterCode];
        }
      });
    });

    return filters;
  },
  activeIndustries(state, getters) {
    const { urlFilters } = getters;
    const { param } = SearchConfig.getMap().industry;

    if (urlFilters.hasOwnProperty(param)) {
      const industries = urlFilters[param];

      return typeof industries === 'string' ? [industries] : industries;
    }

    return null;
  },
  activeTab(state, getters) {
    return getters.urlFilters.hasOwnProperty('tab')
    && state.availableTabs.indexOf(getters.urlFilters.tab) > -1
      ? getters.urlFilters.tab
      : 'search';
  },
};
